
































































































import { Component, Vue, Prop } from 'vue-property-decorator'

import _color from '@/assets/utils/color'

@Component
export default class VxCard extends Vue {
  @Prop(String) readonly title?: string
  @Prop(String) readonly subtitle?: string
  @Prop({ default: false }) readonly actionButtons!: boolean
  @Prop({ default: 'success' }) readonly actionButtonsColor!: string
  @Prop({ default: false }) readonly noShadow!: boolean
  @Prop({ default: false }) readonly noRadius!: boolean
  @Prop({ default: false }) readonly cardBorder!: boolean
  @Prop({ default: '' }) readonly cardBackground!: string
  @Prop({ default: '' }) readonly contentColor!: string
  @Prop({ default: '' }) readonly titleColor!: string
  @Prop({ default: '' }) readonly subtitleColor!: string

  tempHidden = false
  maxHeight = null
  cardMaxHeight = null
  codeContainerMaxHeight = '0px'

  get hasAction () {
    return this.$slots.actions || this.actionButtons
  }

  get hasHeader () {
    return this.hasAction || (this.title || this.subtitle)
  }

  get styleItems () {
    return { maxHeight: this.maxHeight }
  }

  get cardStyles () {
    const obj = {
      maxHeight: this.cardMaxHeight,
      background: '',
      color: ''
    }

    if (!_color.isColor(this.cardBackground)) {
      obj.background = _color.getColor(this.cardBackground)
    }

    if (!_color.isColor(this.contentColor)) {
      obj.color = _color.getColor(this.contentColor)
    }

    return obj
  }

  get codeContainerStyles () {
    return { maxHeight: this.codeContainerMaxHeight }
  }

  get cardClasses () {
    let str = ''

    // Add bg class
    if (_color.isColor(this.cardBackground)) {
      str += ` bg-${this.cardBackground}`
    }

    // add content color
    if (_color.isColor(this.contentColor)) {
      str += ` text-${this.contentColor}`
    }

    return str.trim()
  }

  get titleStyles () {
    return {
      color: _color.getColor(this.titleColor)
    }
  }

  get titleClasses () {
    let str = ''

    // add content color
    if (_color.isColor(this.titleColor)) {
      str += ` text-${this.titleColor}`
    }

    return str.trim()
  }

  get subtitleStyles () {
    const obj = { color: '' }

    if (!_color.isColor(this.subtitleColor)) {
      obj.color = _color.getColor(this.subtitleColor)
    }

    return obj
  }

  get subtitleClasses () {
    let str = ''

    // add content color
    if (_color.isColor(this.subtitleColor)) {
      str += ` text-${this.subtitleColor}`
    }

    return str.trim()
  }
}
